import React from 'react'
import Footer from '../../Layout/Footer';

const PrivacyPolicy = () => {
    return (
        <>
            {/* Navigation */}
            <nav>
                <div className="nav-container">
                    <h1 className="logo">Raivens Technologies</h1>
                    <div className="nav-buttons">
                        <a href="/login" className="button button-primary">Login</a>
                        <a href="/login" className="button button-primary">Register</a>
                    </div>
                </div>
            </nav>
            <div className='common-wrap'>
                <div className='container'>
                    <h2 className='section-title mb-4'><strong>Privacy Policy</strong></h2>
                    <div className='content'>
                
      
      <p>Welcome to Wirelays.com (the “Site”, “we”, “us”, or “our”). This Privacy Policy explains how we collect, use, and protect your personal information when you visit our Site, use our services, or make a purchase from www.bankingdevice.com (the “Ordering Portal”) and any other communication or transactions with us (collectively, the “Services”).</p>
      <p>By accessing or using our Services, you consent to the collection, use, and disclosure of your information as outlined in this Privacy Policy. If you do not agree with this policy, please refrain from using our Services.</p>

      <h3 className="text-xl font-semibold mt-6">1. Updates to This Privacy Policy</h3>
      <p>We may update this Privacy Policy periodically to reflect changes in our business, legal requirements, or industry practices. Any updates will be posted on our Site with the “Last Updated” date revised accordingly. If required by law, we will notify you of significant changes.</p>

      <h3 className="text-xl font-semibold mt-6">2. Information We Collect</h3>
      <h4 className="font-semibold">A. Information You Provide Directly</h4>
      <ul className="list-disc pl-6">
        <li>Contact Details: Name, phone number, email address, billing/shipping address.</li>
        <li>Order Information: Purchase history, transaction details, invoices, and order confirmations.</li>
        <li>Account Details: Username, password, security questions for account access.</li>
        <li>Shopping Preferences: Items viewed, added to cart, wish-listed.</li>
        <li>Customer Support Data: Communications with us via email, chat, or phone.</li>
      </ul>

      <h4 className="font-semibold mt-4">B. Information Collected Automatically (Cookies & Usage Data)</h4>
      <ul className="list-disc pl-6">
        <li>Device Information: Browser type, operating system, IP address, device identifiers.</li>
        <li>Browsing Data: Pages visited, time spent on our Site, referring website, interactions.</li>
        <li>Cookies & Tracking Technologies: Used for analytics, site functionality, and personalized experiences.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-6">3. How We Use Your Information</h3>
      <p>We use your personal data for the following purposes:</p>
      <ul className="list-disc pl-6">
        <li>Processing orders, payments, and deliveries.</li>
        <li>Managing accounts, orders, returns, and refunds.</li>
        <li>Sending transaction confirmations, invoices, and updates.</li>
        <li>Sending promotional offers, newsletters, and product recommendations (with your consent).</li>
        <li>Displaying personalized ads based on your interests.</li>
        <li>Detecting and preventing fraud, unauthorized transactions, or security breaches.</li>
        <li>Protecting the rights, safety, and data of users and our business.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-6">4. How We Share Your Information</h3>
      <p>We do not sell your personal information. However, we may share data with:</p>
      <ul className="list-disc pl-6">
        <li>Payment Processors (e.g., Razorpay, Shopify) for secure transactions.</li>
        <li>Shipping & Fulfillment Providers for order deliveries.</li>
        <li>IT & Security Services for fraud detection and data protection.</li>
      </ul>

      <h3 className="text-xl font-semibold mt-6">5. Contact Us</h3>
      <p>If you have questions, concerns, or requests related to privacy, contact us:</p>
      <p><strong>🏣 Registered Address:</strong> Raivens Technologies Pvt. Ltd., Sonwa Road, Near Power House, Tonk, Rajasthan, India</p>
      <p><strong>🏭 Manufacturing Unit:</strong> Plot No 4, Laxmi Vilas, Choudhary Colony, Sawai Madhopur Road, Tonk, Rajasthan, India - 304001</p>
      <p><strong>📧 Email:</strong> info@raivens.com</p>
      <p><strong>📞 Phone:</strong> +91 9358409099</p>

      <p className="mt-6">By using our Site, you acknowledge that you have read and understood this Privacy Policy.</p>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default PrivacyPolicy